/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BREEDER v2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CellChangesIn,
  CopyPlan,
  CountOut,
  CreateRowsIn,
  DeleteRowsIn,
  HTTPValidationError,
  HistoryIn,
  HistoryPresetsOut,
  KtPlan,
  KtRun,
  LineKtExecuteIn,
  LineKtIn,
  MeasurementsRowsParams,
  MeasurementsTrialVisualizationParams,
  PageOut,
  ParallelCopyExecuteIn,
  ParallelCopyIn,
  SubplotAverageIn,
  TableOut,
  Trait,
  TrialHistory,
  TrialOverviewOut,
  UpdateResult,
  VisualResult
} from '../model';

import { apiFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMeasurementsHistoryPresetsUrl = () => {




  return `/api/v1/history/presets`
}

/**
 * @summary The default field list (the legacy Alap lista) and trend field of a trial history
 */
export const measurementsHistoryPresets = async ( options?: Parameters<typeof apiFetch>[1]): Promise<HistoryPresetsOut> => {

  return apiFetch<HistoryPresetsOut>(getMeasurementsHistoryPresetsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeasurementsHistoryPresetsQueryKey = () => {
    return [
    `/api/v1/history/presets`
    ] as const;
    }


export const getMeasurementsHistoryPresetsQueryOptions = <TData = Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeasurementsHistoryPresetsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof measurementsHistoryPresets>>> = ({ signal }) => measurementsHistoryPresets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeasurementsHistoryPresetsQueryResult = NonNullable<Awaited<ReturnType<typeof measurementsHistoryPresets>>>
export type MeasurementsHistoryPresetsQueryError = unknown


export function useMeasurementsHistoryPresets<TData = Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsHistoryPresets>>,
          TError,
          Awaited<ReturnType<typeof measurementsHistoryPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsHistoryPresets<TData = Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsHistoryPresets>>,
          TError,
          Awaited<ReturnType<typeof measurementsHistoryPresets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsHistoryPresets<TData = Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The default field list (the legacy Alap lista) and trend field of a trial history
 */

export function useMeasurementsHistoryPresets<TData = Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsHistoryPresets>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeasurementsHistoryPresetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMeasurementsTablesUrl = () => {




  return `/api/v1/measurement-tables`
}

/**
 * @summary The plot register and the plot-keyed measurement tables with their columns
 */
export const measurementsTables = async ( options?: Parameters<typeof apiFetch>[1]): Promise<TableOut[]> => {

  return apiFetch<TableOut[]>(getMeasurementsTablesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeasurementsTablesQueryKey = () => {
    return [
    `/api/v1/measurement-tables`
    ] as const;
    }


export const getMeasurementsTablesQueryOptions = <TData = Awaited<ReturnType<typeof measurementsTables>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTables>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeasurementsTablesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof measurementsTables>>> = ({ signal }) => measurementsTables({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof measurementsTables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeasurementsTablesQueryResult = NonNullable<Awaited<ReturnType<typeof measurementsTables>>>
export type MeasurementsTablesQueryError = unknown


export function useMeasurementsTables<TData = Awaited<ReturnType<typeof measurementsTables>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsTables>>,
          TError,
          Awaited<ReturnType<typeof measurementsTables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsTables<TData = Awaited<ReturnType<typeof measurementsTables>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsTables>>,
          TError,
          Awaited<ReturnType<typeof measurementsTables>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsTables<TData = Awaited<ReturnType<typeof measurementsTables>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTables>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The plot register and the plot-keyed measurement tables with their columns
 */

export function useMeasurementsTables<TData = Awaited<ReturnType<typeof measurementsTables>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTables>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeasurementsTablesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMeasurementsVisualTraitsUrl = () => {




  return `/api/v1/visual-traits`
}

/**
 * @summary Classified traits with stored units and supported visualizations
 */
export const measurementsVisualTraits = async ( options?: Parameters<typeof apiFetch>[1]): Promise<Trait[]> => {

  return apiFetch<Trait[]>(getMeasurementsVisualTraitsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeasurementsVisualTraitsQueryKey = () => {
    return [
    `/api/v1/visual-traits`
    ] as const;
    }


export const getMeasurementsVisualTraitsQueryOptions = <TData = Awaited<ReturnType<typeof measurementsVisualTraits>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsVisualTraits>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeasurementsVisualTraitsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof measurementsVisualTraits>>> = ({ signal }) => measurementsVisualTraits({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof measurementsVisualTraits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeasurementsVisualTraitsQueryResult = NonNullable<Awaited<ReturnType<typeof measurementsVisualTraits>>>
export type MeasurementsVisualTraitsQueryError = unknown


export function useMeasurementsVisualTraits<TData = Awaited<ReturnType<typeof measurementsVisualTraits>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsVisualTraits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsVisualTraits>>,
          TError,
          Awaited<ReturnType<typeof measurementsVisualTraits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsVisualTraits<TData = Awaited<ReturnType<typeof measurementsVisualTraits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsVisualTraits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsVisualTraits>>,
          TError,
          Awaited<ReturnType<typeof measurementsVisualTraits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsVisualTraits<TData = Awaited<ReturnType<typeof measurementsVisualTraits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsVisualTraits>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Classified traits with stored units and supported visualizations
 */

export function useMeasurementsVisualTraits<TData = Awaited<ReturnType<typeof measurementsVisualTraits>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsVisualTraits>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeasurementsVisualTraitsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMeasurementsLineKtExecuteUrl = (ev: number,) => {




  return `/api/v1/years/${ev}/measurements/szf/kt-to-line`
}

/**
 * @summary Carry the previewed KTs to the lines (one undoable operation)
 */
export const measurementsLineKtExecute = async (ev: number,
    lineKtExecuteIn: LineKtExecuteIn, options?: Parameters<typeof apiFetch>[1]): Promise<KtRun> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<KtRun>(getMeasurementsLineKtExecuteUrl(ev),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(lineKtExecuteIn)
  }
);}





export const getMeasurementsLineKtExecuteMutationKey = () => ['measurementsLineKtExecute'] as const;

export const getMeasurementsLineKtExecuteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsLineKtExecute>>, TError,MeasurementsLineKtExecuteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof measurementsLineKtExecute>>, TError,MeasurementsLineKtExecuteMutationVariables, TContext> => {

const mutationKey = getMeasurementsLineKtExecuteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof measurementsLineKtExecute>>, MeasurementsLineKtExecuteMutationVariables> = (props) => {
          const {ev,data} = props ?? {};

          return  measurementsLineKtExecute(ev,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeasurementsLineKtExecuteMutationResult = NonNullable<Awaited<ReturnType<typeof measurementsLineKtExecute>>>
    export type MeasurementsLineKtExecuteMutationBody = LineKtExecuteIn
    export type MeasurementsLineKtExecuteMutationError = HTTPValidationError
    export type MeasurementsLineKtExecuteMutationVariables = {ev: number;data: LineKtExecuteIn}

    /**
 * @summary Carry the previewed KTs to the lines (one undoable operation)
 */
export const useMeasurementsLineKtExecute = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsLineKtExecute>>, TError,MeasurementsLineKtExecuteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof measurementsLineKtExecute>>,
        TError,
        MeasurementsLineKtExecuteMutationVariables,
        TContext
      > => {
      return useMutation(getMeasurementsLineKtExecuteMutationOptions(options), queryClient);
    }
    export const getMeasurementsLineKtPreviewUrl = (ev: number,) => {




  return `/api/v1/years/${ev}/measurements/szf/kt-to-line/preview`
}

/**
 * @summary What carrying typed KTs to their lines' Alap rows of the season and Pheno would change
 */
export const measurementsLineKtPreview = async (ev: number,
    lineKtIn: LineKtIn, options?: Parameters<typeof apiFetch>[1]): Promise<KtPlan> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<KtPlan>(getMeasurementsLineKtPreviewUrl(ev),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(lineKtIn)
  }
);}





export const getMeasurementsLineKtPreviewMutationKey = () => ['measurementsLineKtPreview'] as const;

export const getMeasurementsLineKtPreviewMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsLineKtPreview>>, TError,MeasurementsLineKtPreviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof measurementsLineKtPreview>>, TError,MeasurementsLineKtPreviewMutationVariables, TContext> => {

const mutationKey = getMeasurementsLineKtPreviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof measurementsLineKtPreview>>, MeasurementsLineKtPreviewMutationVariables> = (props) => {
          const {ev,data} = props ?? {};

          return  measurementsLineKtPreview(ev,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeasurementsLineKtPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof measurementsLineKtPreview>>>
    export type MeasurementsLineKtPreviewMutationBody = LineKtIn
    export type MeasurementsLineKtPreviewMutationError = HTTPValidationError
    export type MeasurementsLineKtPreviewMutationVariables = {ev: number;data: LineKtIn}

    /**
 * @summary What carrying typed KTs to their lines' Alap rows of the season and Pheno would change
 */
export const useMeasurementsLineKtPreview = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsLineKtPreview>>, TError,MeasurementsLineKtPreviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof measurementsLineKtPreview>>,
        TError,
        MeasurementsLineKtPreviewMutationVariables,
        TContext
      > => {
      return useMutation(getMeasurementsLineKtPreviewMutationOptions(options), queryClient);
    }
    export const getMeasurementsRowsUrl = (ev: number,
    table: string,
    params?: MeasurementsRowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/years/${ev}/measurements/${table}?${stringifiedParams}` : `/api/v1/years/${ev}/measurements/${table}`
}

/**
 * @summary Rows of a table with their plot keys and genotype (keyset paging)
 */
export const measurementsRows = async (ev: number,
    table: string,
    params?: MeasurementsRowsParams, options?: Parameters<typeof apiFetch>[1]): Promise<PageOut> => {

  return apiFetch<PageOut>(getMeasurementsRowsUrl(ev,table,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeasurementsRowsQueryKey = (ev: number,
    table: string,
    params?: MeasurementsRowsParams,) => {
    return [
    `/api/v1/years/${ev}/measurements/${table}`, ...(params ? [params] : [])
    ] as const;
    }


export const getMeasurementsRowsQueryOptions = <TData = Awaited<ReturnType<typeof measurementsRows>>, TError = HTTPValidationError>(ev: number,
    table: string,
    params?: MeasurementsRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsRows>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeasurementsRowsQueryKey(ev,table,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof measurementsRows>>> = ({ signal }) => measurementsRows(ev,table,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: ev !== null && ev !== undefined && table !== null && table !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof measurementsRows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeasurementsRowsQueryResult = NonNullable<Awaited<ReturnType<typeof measurementsRows>>>
export type MeasurementsRowsQueryError = HTTPValidationError


export function useMeasurementsRows<TData = Awaited<ReturnType<typeof measurementsRows>>, TError = HTTPValidationError>(
 ev: number,
    table: string,
    params: undefined |  MeasurementsRowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsRows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsRows>>,
          TError,
          Awaited<ReturnType<typeof measurementsRows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsRows<TData = Awaited<ReturnType<typeof measurementsRows>>, TError = HTTPValidationError>(
 ev: number,
    table: string,
    params?: MeasurementsRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsRows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsRows>>,
          TError,
          Awaited<ReturnType<typeof measurementsRows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsRows<TData = Awaited<ReturnType<typeof measurementsRows>>, TError = HTTPValidationError>(
 ev: number,
    table: string,
    params?: MeasurementsRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsRows>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Rows of a table with their plot keys and genotype (keyset paging)
 */

export function useMeasurementsRows<TData = Awaited<ReturnType<typeof measurementsRows>>, TError = HTTPValidationError>(
 ev: number,
    table: string,
    params?: MeasurementsRowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsRows>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeasurementsRowsQueryOptions(ev,table,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMeasurementsUpdateCellsUrl = (ev: number,
    table: string,) => {




  return `/api/v1/years/${ev}/measurements/${table}`
}

/**
 * @summary Edit cells (compare-and-set, all or nothing)
 */
export const measurementsUpdateCells = async (ev: number,
    table: string,
    cellChangesIn: CellChangesIn, options?: Parameters<typeof apiFetch>[1]): Promise<UpdateResult> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<UpdateResult>(getMeasurementsUpdateCellsUrl(ev,table),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cellChangesIn)
  }
);}





export const getMeasurementsUpdateCellsMutationKey = () => ['measurementsUpdateCells'] as const;

export const getMeasurementsUpdateCellsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsUpdateCells>>, TError,MeasurementsUpdateCellsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof measurementsUpdateCells>>, TError,MeasurementsUpdateCellsMutationVariables, TContext> => {

const mutationKey = getMeasurementsUpdateCellsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof measurementsUpdateCells>>, MeasurementsUpdateCellsMutationVariables> = (props) => {
          const {ev,table,data} = props ?? {};

          return  measurementsUpdateCells(ev,table,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeasurementsUpdateCellsMutationResult = NonNullable<Awaited<ReturnType<typeof measurementsUpdateCells>>>
    export type MeasurementsUpdateCellsMutationBody = CellChangesIn
    export type MeasurementsUpdateCellsMutationError = HTTPValidationError
    export type MeasurementsUpdateCellsMutationVariables = {ev: number;table: string;data: CellChangesIn}

    /**
 * @summary Edit cells (compare-and-set, all or nothing)
 */
export const useMeasurementsUpdateCells = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsUpdateCells>>, TError,MeasurementsUpdateCellsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof measurementsUpdateCells>>,
        TError,
        MeasurementsUpdateCellsMutationVariables,
        TContext
      > => {
      return useMutation(getMeasurementsUpdateCellsMutationOptions(options), queryClient);
    }
    export const getMeasurementsDeleteRowsUrl = (ev: number,
    table: string,) => {




  return `/api/v1/years/${ev}/measurements/${table}/delete`
}

/**
 * @summary Delete measurement rows (the plots stay; undoable)
 */
export const measurementsDeleteRows = async (ev: number,
    table: string,
    deleteRowsIn: DeleteRowsIn, options?: Parameters<typeof apiFetch>[1]): Promise<CountOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<CountOut>(getMeasurementsDeleteRowsUrl(ev,table),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteRowsIn)
  }
);}





export const getMeasurementsDeleteRowsMutationKey = () => ['measurementsDeleteRows'] as const;

export const getMeasurementsDeleteRowsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsDeleteRows>>, TError,MeasurementsDeleteRowsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof measurementsDeleteRows>>, TError,MeasurementsDeleteRowsMutationVariables, TContext> => {

const mutationKey = getMeasurementsDeleteRowsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof measurementsDeleteRows>>, MeasurementsDeleteRowsMutationVariables> = (props) => {
          const {ev,table,data} = props ?? {};

          return  measurementsDeleteRows(ev,table,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeasurementsDeleteRowsMutationResult = NonNullable<Awaited<ReturnType<typeof measurementsDeleteRows>>>
    export type MeasurementsDeleteRowsMutationBody = DeleteRowsIn
    export type MeasurementsDeleteRowsMutationError = HTTPValidationError
    export type MeasurementsDeleteRowsMutationVariables = {ev: number;table: string;data: DeleteRowsIn}

    /**
 * @summary Delete measurement rows (the plots stay; undoable)
 */
export const useMeasurementsDeleteRows = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsDeleteRows>>, TError,MeasurementsDeleteRowsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof measurementsDeleteRows>>,
        TError,
        MeasurementsDeleteRowsMutationVariables,
        TContext
      > => {
      return useMutation(getMeasurementsDeleteRowsMutationOptions(options), queryClient);
    }
    export const getMeasurementsParallelCopyExecuteUrl = (ev: number,
    table: string,) => {




  return `/api/v1/years/${ev}/measurements/${table}/parallel-copy`
}

/**
 * @summary Apply a previewed parallel-experiment copy (undoable)
 */
export const measurementsParallelCopyExecute = async (ev: number,
    table: string,
    parallelCopyExecuteIn: ParallelCopyExecuteIn, options?: Parameters<typeof apiFetch>[1]): Promise<CountOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<CountOut>(getMeasurementsParallelCopyExecuteUrl(ev,table),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(parallelCopyExecuteIn)
  }
);}





export const getMeasurementsParallelCopyExecuteMutationKey = () => ['measurementsParallelCopyExecute'] as const;

export const getMeasurementsParallelCopyExecuteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsParallelCopyExecute>>, TError,MeasurementsParallelCopyExecuteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof measurementsParallelCopyExecute>>, TError,MeasurementsParallelCopyExecuteMutationVariables, TContext> => {

const mutationKey = getMeasurementsParallelCopyExecuteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof measurementsParallelCopyExecute>>, MeasurementsParallelCopyExecuteMutationVariables> = (props) => {
          const {ev,table,data} = props ?? {};

          return  measurementsParallelCopyExecute(ev,table,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeasurementsParallelCopyExecuteMutationResult = NonNullable<Awaited<ReturnType<typeof measurementsParallelCopyExecute>>>
    export type MeasurementsParallelCopyExecuteMutationBody = ParallelCopyExecuteIn
    export type MeasurementsParallelCopyExecuteMutationError = HTTPValidationError
    export type MeasurementsParallelCopyExecuteMutationVariables = {ev: number;table: string;data: ParallelCopyExecuteIn}

    /**
 * @summary Apply a previewed parallel-experiment copy (undoable)
 */
export const useMeasurementsParallelCopyExecute = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsParallelCopyExecute>>, TError,MeasurementsParallelCopyExecuteMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof measurementsParallelCopyExecute>>,
        TError,
        MeasurementsParallelCopyExecuteMutationVariables,
        TContext
      > => {
      return useMutation(getMeasurementsParallelCopyExecuteMutationOptions(options), queryClient);
    }
    export const getMeasurementsParallelCopyPreviewUrl = (ev: number,
    table: string,) => {




  return `/api/v1/years/${ev}/measurements/${table}/parallel-copy/preview`
}

/**
 * @summary What copying a parallel experiment into its main trial (ViKis/ViParc) would change
 */
export const measurementsParallelCopyPreview = async (ev: number,
    table: string,
    parallelCopyIn: ParallelCopyIn, options?: Parameters<typeof apiFetch>[1]): Promise<CopyPlan> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<CopyPlan>(getMeasurementsParallelCopyPreviewUrl(ev,table),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(parallelCopyIn)
  }
);}





export const getMeasurementsParallelCopyPreviewMutationKey = () => ['measurementsParallelCopyPreview'] as const;

export const getMeasurementsParallelCopyPreviewMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsParallelCopyPreview>>, TError,MeasurementsParallelCopyPreviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof measurementsParallelCopyPreview>>, TError,MeasurementsParallelCopyPreviewMutationVariables, TContext> => {

const mutationKey = getMeasurementsParallelCopyPreviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof measurementsParallelCopyPreview>>, MeasurementsParallelCopyPreviewMutationVariables> = (props) => {
          const {ev,table,data} = props ?? {};

          return  measurementsParallelCopyPreview(ev,table,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeasurementsParallelCopyPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof measurementsParallelCopyPreview>>>
    export type MeasurementsParallelCopyPreviewMutationBody = ParallelCopyIn
    export type MeasurementsParallelCopyPreviewMutationError = HTTPValidationError
    export type MeasurementsParallelCopyPreviewMutationVariables = {ev: number;table: string;data: ParallelCopyIn}

    /**
 * @summary What copying a parallel experiment into its main trial (ViKis/ViParc) would change
 */
export const useMeasurementsParallelCopyPreview = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsParallelCopyPreview>>, TError,MeasurementsParallelCopyPreviewMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof measurementsParallelCopyPreview>>,
        TError,
        MeasurementsParallelCopyPreviewMutationVariables,
        TContext
      > => {
      return useMutation(getMeasurementsParallelCopyPreviewMutationOptions(options), queryClient);
    }
    export const getMeasurementsCreateRowsUrl = (ev: number,
    table: string,) => {




  return `/api/v1/years/${ev}/measurements/${table}/rows`
}

/**
 * @summary Empty rows for the register plots of a trial or trial group (data entry)
 */
export const measurementsCreateRows = async (ev: number,
    table: string,
    createRowsIn: CreateRowsIn, options?: Parameters<typeof apiFetch>[1]): Promise<CountOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<CountOut>(getMeasurementsCreateRowsUrl(ev,table),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createRowsIn)
  }
);}





export const getMeasurementsCreateRowsMutationKey = () => ['measurementsCreateRows'] as const;

export const getMeasurementsCreateRowsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsCreateRows>>, TError,MeasurementsCreateRowsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof measurementsCreateRows>>, TError,MeasurementsCreateRowsMutationVariables, TContext> => {

const mutationKey = getMeasurementsCreateRowsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof measurementsCreateRows>>, MeasurementsCreateRowsMutationVariables> = (props) => {
          const {ev,table,data} = props ?? {};

          return  measurementsCreateRows(ev,table,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeasurementsCreateRowsMutationResult = NonNullable<Awaited<ReturnType<typeof measurementsCreateRows>>>
    export type MeasurementsCreateRowsMutationBody = CreateRowsIn
    export type MeasurementsCreateRowsMutationError = HTTPValidationError
    export type MeasurementsCreateRowsMutationVariables = {ev: number;table: string;data: CreateRowsIn}

    /**
 * @summary Empty rows for the register plots of a trial or trial group (data entry)
 */
export const useMeasurementsCreateRows = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsCreateRows>>, TError,MeasurementsCreateRowsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof measurementsCreateRows>>,
        TError,
        MeasurementsCreateRowsMutationVariables,
        TContext
      > => {
      return useMutation(getMeasurementsCreateRowsMutationOptions(options), queryClient);
    }
    export const getMeasurementsSubplotAverageUrl = (ev: number,
    table: string,) => {




  return `/api/v1/years/${ev}/measurements/${table}/subplot-average`
}

/**
 * @summary Write the subplot means into the Alp 0 rows (undoable)
 */
export const measurementsSubplotAverage = async (ev: number,
    table: string,
    subplotAverageIn: SubplotAverageIn, options?: Parameters<typeof apiFetch>[1]): Promise<CountOut> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<CountOut>(getMeasurementsSubplotAverageUrl(ev,table),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(subplotAverageIn)
  }
);}





export const getMeasurementsSubplotAverageMutationKey = () => ['measurementsSubplotAverage'] as const;

export const getMeasurementsSubplotAverageMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsSubplotAverage>>, TError,MeasurementsSubplotAverageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof measurementsSubplotAverage>>, TError,MeasurementsSubplotAverageMutationVariables, TContext> => {

const mutationKey = getMeasurementsSubplotAverageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof measurementsSubplotAverage>>, MeasurementsSubplotAverageMutationVariables> = (props) => {
          const {ev,table,data} = props ?? {};

          return  measurementsSubplotAverage(ev,table,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeasurementsSubplotAverageMutationResult = NonNullable<Awaited<ReturnType<typeof measurementsSubplotAverage>>>
    export type MeasurementsSubplotAverageMutationBody = SubplotAverageIn
    export type MeasurementsSubplotAverageMutationError = HTTPValidationError
    export type MeasurementsSubplotAverageMutationVariables = {ev: number;table: string;data: SubplotAverageIn}

    /**
 * @summary Write the subplot means into the Alp 0 rows (undoable)
 */
export const useMeasurementsSubplotAverage = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsSubplotAverage>>, TError,MeasurementsSubplotAverageMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof measurementsSubplotAverage>>,
        TError,
        MeasurementsSubplotAverageMutationVariables,
        TContext
      > => {
      return useMutation(getMeasurementsSubplotAverageMutationOptions(options), queryClient);
    }
    export const getMeasurementsOverviewUrl = (ev: number,) => {




  return `/api/v1/years/${ev}/trials`
}

/**
 * @summary Trials of a year: sites, register plots and rows per measurement table
 */
export const measurementsOverview = async (ev: number, options?: Parameters<typeof apiFetch>[1]): Promise<TrialOverviewOut[]> => {

  return apiFetch<TrialOverviewOut[]>(getMeasurementsOverviewUrl(ev),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeasurementsOverviewQueryKey = (ev: number,) => {
    return [
    `/api/v1/years/${ev}/trials`
    ] as const;
    }


export const getMeasurementsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof measurementsOverview>>, TError = HTTPValidationError>(ev: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeasurementsOverviewQueryKey(ev);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof measurementsOverview>>> = ({ signal }) => measurementsOverview(ev, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: ev !== null && ev !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof measurementsOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeasurementsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof measurementsOverview>>>
export type MeasurementsOverviewQueryError = HTTPValidationError


export function useMeasurementsOverview<TData = Awaited<ReturnType<typeof measurementsOverview>>, TError = HTTPValidationError>(
 ev: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsOverview>>,
          TError,
          Awaited<ReturnType<typeof measurementsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsOverview<TData = Awaited<ReturnType<typeof measurementsOverview>>, TError = HTTPValidationError>(
 ev: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsOverview>>,
          TError,
          Awaited<ReturnType<typeof measurementsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsOverview<TData = Awaited<ReturnType<typeof measurementsOverview>>, TError = HTTPValidationError>(
 ev: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Trials of a year: sites, register plots and rows per measurement table
 */

export function useMeasurementsOverview<TData = Awaited<ReturnType<typeof measurementsOverview>>, TError = HTTPValidationError>(
 ev: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsOverview>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeasurementsOverviewQueryOptions(ev,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMeasurementsTrialHistoryUrl = (ev: number,
    kis: string,) => {




  return `/api/v1/years/${ev}/trials/${kis}/history`
}

/**
 * @summary A trial's plots with their source plots generations back (read-only)
 */
export const measurementsTrialHistory = async (ev: number,
    kis: string,
    historyIn: HistoryIn, options?: Parameters<typeof apiFetch>[1]): Promise<TrialHistory> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<TrialHistory>(getMeasurementsTrialHistoryUrl(ev,kis),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(historyIn)
  }
);}





export const getMeasurementsTrialHistoryMutationKey = () => ['measurementsTrialHistory'] as const;

export const getMeasurementsTrialHistoryMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsTrialHistory>>, TError,MeasurementsTrialHistoryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof measurementsTrialHistory>>, TError,MeasurementsTrialHistoryMutationVariables, TContext> => {

const mutationKey = getMeasurementsTrialHistoryMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof measurementsTrialHistory>>, MeasurementsTrialHistoryMutationVariables> = (props) => {
          const {ev,kis,data} = props ?? {};

          return  measurementsTrialHistory(ev,kis,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MeasurementsTrialHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof measurementsTrialHistory>>>
    export type MeasurementsTrialHistoryMutationBody = HistoryIn
    export type MeasurementsTrialHistoryMutationError = HTTPValidationError
    export type MeasurementsTrialHistoryMutationVariables = {ev: number;kis: string;data: HistoryIn}

    /**
 * @summary A trial's plots with their source plots generations back (read-only)
 */
export const useMeasurementsTrialHistory = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof measurementsTrialHistory>>, TError,MeasurementsTrialHistoryMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof measurementsTrialHistory>>,
        TError,
        MeasurementsTrialHistoryMutationVariables,
        TContext
      > => {
      return useMutation(getMeasurementsTrialHistoryMutationOptions(options), queryClient);
    }
    export const getMeasurementsTrialVisualizationUrl = (ev: number,
    kis: string,
    params: MeasurementsTrialVisualizationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["fields"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/years/${ev}/trials/${kis}/visualization?${stringifiedParams}` : `/api/v1/years/${ev}/trials/${kis}/visualization`
}

/**
 * @summary Full-scope summaries and capped points; paginated exact records
 */
export const measurementsTrialVisualization = async (ev: number,
    kis: string,
    params: MeasurementsTrialVisualizationParams, options?: Parameters<typeof apiFetch>[1]): Promise<VisualResult> => {

  return apiFetch<VisualResult>(getMeasurementsTrialVisualizationUrl(ev,kis,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMeasurementsTrialVisualizationQueryKey = (ev: number,
    kis: string,
    params?: MeasurementsTrialVisualizationParams,) => {
    return [
    `/api/v1/years/${ev}/trials/${kis}/visualization`, ...(params ? [params] : [])
    ] as const;
    }


export const getMeasurementsTrialVisualizationQueryOptions = <TData = Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError = HTTPValidationError>(ev: number,
    kis: string,
    params: MeasurementsTrialVisualizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeasurementsTrialVisualizationQueryKey(ev,kis,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof measurementsTrialVisualization>>> = ({ signal }) => measurementsTrialVisualization(ev,kis,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: ev !== null && ev !== undefined && kis !== null && kis !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeasurementsTrialVisualizationQueryResult = NonNullable<Awaited<ReturnType<typeof measurementsTrialVisualization>>>
export type MeasurementsTrialVisualizationQueryError = HTTPValidationError


export function useMeasurementsTrialVisualization<TData = Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError = HTTPValidationError>(
 ev: number,
    kis: string,
    params: MeasurementsTrialVisualizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsTrialVisualization>>,
          TError,
          Awaited<ReturnType<typeof measurementsTrialVisualization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsTrialVisualization<TData = Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError = HTTPValidationError>(
 ev: number,
    kis: string,
    params: MeasurementsTrialVisualizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof measurementsTrialVisualization>>,
          TError,
          Awaited<ReturnType<typeof measurementsTrialVisualization>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeasurementsTrialVisualization<TData = Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError = HTTPValidationError>(
 ev: number,
    kis: string,
    params: MeasurementsTrialVisualizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Full-scope summaries and capped points; paginated exact records
 */

export function useMeasurementsTrialVisualization<TData = Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError = HTTPValidationError>(
 ev: number,
    kis: string,
    params: MeasurementsTrialVisualizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof measurementsTrialVisualization>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeasurementsTrialVisualizationQueryOptions(ev,kis,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






